/* Section vidéo */
const videoContainers = document.querySelectorAll('.video-container');


if (typeof(videoContainers) != 'undefined' && videoContainers != null) {
    videoContainers.forEach(container => {

        const button = container.querySelector('.video-container__button');
        const video = container.querySelector('video');
        const iframe = container.querySelector('iframe');

        button.addEventListener('click', () => {

            // Active le container
            container.classList.add('video-container--active');

            // Cas 1 : vidéo HTML5
            if (video) {
                video.play();
            }

            // Cas 2 : iframe Youtube / Vimeo / Dailymotion
            if (iframe) {

                let src = iframe.getAttribute('src');

                // Évite de rajouter autoplay plusieurs fois
                if (!src.includes('autoplay=1')) {

                    const separator = src.includes('?') ? '&' : '?';

                    iframe.setAttribute(
                        'src',
                        `${src}${separator}autoplay=1`
                    );
                }
            }

        });

    });
}
